// Shared helpers for the inventory module UI.

/** Format a number as Indian Rupee currency. */
export function formatCurrency(value: number | undefined | null): string {
  const n = typeof value === 'number' && isFinite(value) ? value : 0;
  return '₹' + n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/** Format a quantity, trimming trailing zeros (e.g. 2.500 -> "2.5"). */
export function formatQty(value: number | undefined | null): string {
  const n = typeof value === 'number' && isFinite(value) ? value : 0;
  return Number(n.toFixed(3)).toLocaleString('en-IN');
}

/** Format an ISO date string as a short readable date. */
export function formatDate(iso?: string): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

/** Format an ISO date string as date + time. */
export function formatDateTime(iso?: string): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleString('en-IN', {
    day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
}
